import React from 'react'

const handleClick = (e) => {
    e.stopPropagation();
}

function ImageModal (props) {
    return (
        <div className="image-modal" onClick={() => props.setImageUrl("")}>
            <div className="image-modal__wrapper col-6">
                <img alt="" src={props.imageUrl} onClick={handleClick}/>
                <div className="image-modal__cancel" onClick={() => props.setImageUrl("")}>✖</div>
            </div>
        </div>
    )
}

export default ImageModal;